import { Title, Stack } from '@mantine/core';
import heroImage from '../../assets/landing-page1.webp';
import { ChevronDownIcon } from 'lucide-react';
import './LandingPage.css';

const HeroSection = () => {
  const handleScrollDown = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth',
    });
  };

  return (
    <div className='hero-section'>
      <div className='text-container'>
        <Stack gap='lg'>
          <Title
            order={1}
            c='white'
            lh={1}
            mt='xl'
            mb={0}
            fw={700}
            fz={{ base: '2.25rem', md: '4rem', xl: '5rem' }}
          >
            Everything your law firm needs.
          </Title>
          <Title
            order={2}
            opacity={0.9}
            c='white'
            lh={1}
            m='0'
            fw={400}
            fz={{ base: '1.4rem', md: '2.4rem', xl: '3.2rem' }}
          >
            None of what it doesn't.
          </Title>
        </Stack>
      </div>
      <img src={heroImage} alt='Hero' className='hero-image' />
      <Title
        order={3}
        fw={400}
        lh={1}
        ta='center'
        fz={{ base: '1.25rem', md: '1.75rem', xl: '2rem' }}
        className='hero-tagline'
        style={{
          position: 'absolute',
          bottom: '160px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '100%',
          maxWidth: '1200px',
          padding: '0 1rem',
        }}
      >
        Practice management software that works for you — not the other way
        around.
      </Title>
      <button
        onClick={handleScrollDown}
        className='scroll-indicator'
        aria-label='Scroll down to see more'
      >
        <ChevronDownIcon size={32} strokeWidth={1.5} />
      </button>
    </div>
  );
};

export default HeroSection;
